import { render, staticRenderFns } from "./aliconfig.vue?vue&type=template&id=2bee930f&scoped=true"
import script from "./aliconfig.vue?vue&type=script&lang=js"
export * from "./aliconfig.vue?vue&type=script&lang=js"
import style1 from "./aliconfig.vue?vue&type=style&index=1&id=2bee930f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bee930f",
  null
  
)

export default component.exports